import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import GalleryUpdate from "./GalleryUpdate";
import GalleryCategoryManager from "./GalleryCategoryManager";


export default function Photo() {
  const [open, setOpen] = useState(true);
  const fileInputRef = useRef(null);

  const [category, setCategory] = useState("");
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================= FILE CHANGE =================
  const handlePhotoChange = (e) => {
    const files = Array.from(e.target.files);

    const validFiles = files.filter(
      (file) =>
        (file.type === "image/png" || file.type === "image/jpeg") &&
        file.size <= 1024 * 1024
    );

    const mappedFiles = validFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setPhotos(mappedFiles);
  };

  // ================= REMOVE IMAGE =================
  const removePhoto = (index) => {
    setPhotos((prev) => {
      const updated = [...prev];
      URL.revokeObjectURL(updated[index].preview);
      updated.splice(index, 1);

      const dt = new DataTransfer();
      updated.forEach((item) => dt.items.add(item.file));
      fileInputRef.current.files = dt.files;

      return updated;
    });
  };

  // ================= SUBMIT =================
  const handleSubmit = async () => {
    if (!category.trim() || photos.length === 0) {
      alert("Category and images required");
      return;
    }

    const formData = new FormData();
    formData.append("category", category.trim());
    photos.forEach((item) => formData.append("photos[]", item.file));

    try {
      setLoading(true);

      const res = await axios.post(
        // "https://spst.in/myapp/api/upload_gallery.php",
        "https://atblogin.cubixsystems.com/myapp/api/upload_gallery.php",
        // "http://localhost/myapp-ks/api/upload_gallery.php",
        formData
      );

      alert(res.data.message);

      setCategory("");
      setPhotos([]);
      fileInputRef.current.value = "";
    } catch (err) {
      console.error(err);
      alert("Upload sucess");
      window.location.reload();
    } finally {
      setLoading(false);
    }
  };

  // ================= RESPONSIVE =================
  useEffect(() => {
    const handleResize = () => setOpen(window.innerWidth >= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="container-fluid p-0" style={{overflow:'auto'}}>
      <div
        className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
        style={{
          zIndex: 999,
          cursor: "pointer",
          position: "fixed",
          left: open ? "350px" : "60px",
          top: "0",
          transition: "left 0.3s ease"
        }}
        onClick={() => setOpen(!open)}
      >
        <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
          ☰
        </span>
      </div>

      <div className="d-flex" style={{ height: "100vh" }}>

        {/* LEFT SIDEBAR */}
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease",

          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* RIGHT CONTENT */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddiingLeft: '30px'
          }}
        >
          <div>
            <TopBanner />
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <h4 style={{ fontWeight: "700" }}>Events Updates</h4>
                {/* <label className="form-label fw-bold">Gallery Category</label> */}
                <input
                  type="text"
                  placeholder="Enter Event Name"
                  className="form-control"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold" style={{ color: 'black' }}>
                Upload Images (PNG/JPEG – Max 1MB)
              </label>
              <input
                type="file"
                className="form-control"
                multiple
                accept="image/png,image/jpeg"
                ref={fileInputRef}
                onChange={handlePhotoChange}
              />
            </div>

          </div>




          <div className="row">
            {photos.map((item, index) => (
              <div key={index} className="col-md-3 mb-3 position-relative">
                <button
                  className="btn btn-danger btn-sm position-absolute"
                  style={{ top: 5, right: 5 }}
                  onClick={() => removePhoto(index)}
                >
                  ✕
                </button>
                <img
                  src={item.preview}
                  alt=""
                  className="img-fluid rounded"
                  style={{ height: 150, objectFit: "cover", width: "100%" }}
                />
              </div>
            ))}
          </div>

          <button
            className="btn btn-success mt-3"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Uploading..." : "Save"}
          </button>
          <div className="row">
            <dov className="col-md-9">
              <GalleryUpdate />
            </dov>
            <div className="col-md-3" style={{border:'1px solid orange',paddingTop:'25px'}}>
              <GalleryCategoryManager />
            </div>
          </div>


        </div>

      </div>

    </div>
  );
}
